<script setup>
import { ref, onMounted, computed, onBeforeUnmount } from 'vue';
import * as routeFunctions from '@/helpers/routeFunctions.js';
import { debugLog } from '@/helpers/loggingFunctions.js';
import { useUserStore } from '@/stores/userStore.js';
import { useAuthStore } from '@/stores/authStore.js';
import * as generalFunctions from '@/helpers/generalFunctions.js';
import * as authFunctions from '@/helpers/authFunctions.js';

const authStore = useAuthStore();

const userStore = useUserStore();

const verificationMessage = ref('(resend)');

onMounted(() => {
    debugLog('resources/js/views/layouts/authenticated.vue onMounted');
});

async function logout() {
    debugLog('resources/js/views/layouts/authenticated.vue - Logout triggered');

    generalFunctions.showLoading();

    await authStore
        .logout()
        .then(() => {
            authFunctions.clearStores();
            generalFunctions.hideLoading();
        })
        .catch(() => {
            debugLog('resources/js/views/layouts/authenticated.vue - failed trigger logout!!');
            generalFunctions.hideLoading();
        });
}
</script>

<template>
    <main>
        <div class="authenticated">
            <!--            <div v-if="!userStore.profile.email_verified_at" class="alert alert-danger alert-unverified" role="alert">-->
            <!--                Your email address has not been confirmed yet. Please check your inbox for a confirmation message.-->
            <!--                <span @click="resendVerificationEmail" style="cursor: pointer; text-decoration: underline;">-->
            <!--                    {{ verificationMessage }}-->
            <!--                </span>-->
            <!--            </div>-->
            <!--            <nav class="bg-light p-3  d-flex justify-content-between align-items-center">-->
            <!--                <div>-->
            <!--                    <router-link-->
            <!--                        to="/"-->
            <!--                        class="text-secondary link-gap"-->
            <!--                    >-->
            <!--                        Home-->
            <!--                    </router-link>-->
            <!--                </div>-->
            <!--                <div class="d-flex gap-3 align-items-center">-->
            <!--                    <span-->
            <!--                        @click="logout"-->
            <!--                        class="text-secondary text-decoration-none"-->
            <!--                        style="cursor: pointer;"-->
            <!--                    >-->
            <!--                        Logout-->
            <!--                    </span>-->
            <!--                    <router-link to="profile" class="text-black d-flex align-items-center router-profile">-->
            <!--                        <img class="border border-secondary rounded-circle profile-img" v-if="photoUrl" :src="photoUrl" alt="User photo">-->
            <!--                        <div v-else class="w-7">-->
            <!--                            <i class="profile-icon bi bi-person-circle mr-2"></i>-->
            <!--                        </div>-->
            <!--                    </router-link>-->
            <!--                </div>-->
            <!--            </nav>-->
            <div>
                <router-view></router-view>
            </div>
        </div>

        <div id="loadingOverlay" class="overlay"></div>
        <!--        <div id="loadingSpanner" class="spanner">-->
        <!--            <div class="loader"></div>-->
        <!--            <p>Processing... please wait</p>-->
        <!--        </div>-->
    </main>
</template>

<style scoped>
.link-gap {
    text-underline-offset: 0.4em;
}
.alert-unverified {
    background-color: #ff0202;
    height: 30px;
    font-size: 10pt;
    color: white;
    --bs-alert-padding-x: 0.5rem;
    --bs-alert-padding-y: 0.3rem;
    border-radius: 0;
    margin: 0;
}
</style>
